/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Report_Inventory_Status_OutInputs */

const vi_report_inventory_status_out = /** @type {(inputs: Report_Inventory_Status_OutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hết hàng`)
};

/**

* @param {Report_Inventory_Status_OutInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const report_inventory_status_out = /** @type {((inputs?: Report_Inventory_Status_OutInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Report_Inventory_Status_OutInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_report_inventory_status_out(inputs)
});